import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
/* Components */
import { AppComponent } from './app.component';

/* Modules */
import { PagesModule } from './pages/pages.module';
import { AppRoutingModule } from './app-routing.module';
import { ServiceModule } from './services/service.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/* Pipes en Español */
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

/* Components Terceros */
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// redux
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LY_THEME, LY_THEME_NAME, StyleRenderer, LyTheme2 } from '@alyle/ui';
import { MinimaLight } from '@alyle/ui/themes/minima';

import { ConfigService } from 'src/app/services/config.service';
import { AuthInterceptorService } from 'src/app/models/auth/_models/interceptors/interceptor';
import { MsalService, MsalGuard, MsalBroadcastService} from '@azure/msal-angular';
import {  LogLevel } from '@azure/msal-browser';
import { OauthService } from './services/ouath.service';
import {  RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import OAuthSettings from 'src/assets/config/oauth.json';
// Importar el QRCodeModule
import { QRCodeModule } from 'angularx-qrcode';


function appInitializer(configService: ConfigService) {
  return () => configService.getAppConfig();
}
function initializeOauth(oauthService: OauthService) {
  return () => oauthService.getAppConfig();
}


const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;



export function loggerCallback(logLevel: LogLevel, message: string) {

}


registerLocaleData(localeEs, 'es');




@NgModule({
  declarations: [
    AppComponent,
    
  ],
  imports: [
    BrowserModule,
    PagesModule,
    AppRoutingModule,
    
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgbModule,
    StoreModule.forRoot({}),
    RecaptchaV3Module,
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: true,
      autoPause: false,
    }),
    QRCodeModule,
  ],
  providers: [
    ServiceModule,
    { provide: LOCALE_ID, useValue: 'es' },
    StyleRenderer,
    LyTheme2,
    { provide: LY_THEME_NAME, useValue: 'minima-light' },
    { provide: LY_THEME, useClass: MinimaLight, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [ConfigService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeOauth,
      deps: [OauthService],
      multi: true // Permite múltiples inicializadores
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,useValue:OAuthSettings.siteKey
    },

    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
